import React, { Component } from 'react';
import { connect } from 'react-redux';

import './LoadingDots.scss';

export class LoadingDots extends Component {

  render() {
    const { currentCompany, color } = this.props;
    const accentColor = color || (currentCompany && currentCompany.accent_color ? currentCompany.accent_color : '#184e78');
    const colorStyle = { backgroundColor: accentColor };
    return (
      <div className={'lds-ellipsis' + (this.props.smaller ? ' smaller': '')}>
        <div style={colorStyle}/>
        <div style={colorStyle}/>
        <div style={colorStyle}/>
        <div style={colorStyle}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(LoadingDots);



// WEBPACK FOOTER //
// ./src/components/LoadingDots/index.js